import { Body, Controller, Post } from "@nestjs/common";
import { ApiBody, ApiTags } from "@nestjs/swagger";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { CommonResponseModel } from "@project-management-system/shared-models";
import { LocationService } from "./location.service";
import { LocationDto } from "./location.dto";


@Controller('location')
@ApiTags('/location')
export class LocationController {
    constructor(private service: LocationService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ) { }

    @Post('/getAllLocation')
    async getAllLocation(): Promise<CommonResponseModel> {
        try {
            return await this.service.getAllLocation();
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/createLocation')
    @ApiBody({ type: LocationDto })
    async createLocation(@Body() req: any): Promise<CommonResponseModel> {
        try {
            // console.log(req, 'ppppppppppp');

            return await this.service.createLocation(req);
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }

    }

    @Post('/getActiveAllLocation')
    async getActiveAllLocation(): Promise<CommonResponseModel> {
        try {
            return await this.service.getActiveAllLocation();
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/updateLocation')
    @ApiBody({ type: LocationDto })
    async updateLocation(@Body() req: any): Promise<CommonResponseModel> {
        try {


            return await this.service.updateLocation(req);
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/activateOrDeactivateLocation')
    @ApiBody({ type: LocationDto })
    async activateOrDeactivateLocation(@Body() dto: any, isUpdate: boolean = false): Promise<CommonResponseModel> {
        try {
            return await this.service.activateOrDeactivateLocation(dto);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

}